import { render } from "./AppModalCentered.vue?vue&type=template&id=3dce881a&scoped=true"
import script from "./AppModalCentered.vue?vue&type=script&lang=js"
export * from "./AppModalCentered.vue?vue&type=script&lang=js"

import "./AppModalCentered.vue?vue&type=style&index=0&id=3dce881a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dce881a"]])

export default __exports__